import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class LoaderService {
  private _isLoading = new Subject<boolean>();

  public isLoading$: Observable<boolean>;
  private trueCount: number = 0;

  constructor() {
    this.isLoading$ = this._isLoading;
  }

  setLoading(value: boolean, dontModifyCount: boolean = false) {
    if (value) {
      ++this.trueCount;

      if (this.trueCount == 1) {
        this._isLoading.next(true);
      }

      if (dontModifyCount) {
        --this.trueCount;
      }
    } else {
      --this.trueCount;

      if (this.trueCount == 0) {
        this._isLoading.next(false);
      }

      if (dontModifyCount) {
        ++this.trueCount;
      }
    }
  }
}
